import styled from "styled-components";

export const StyledSectionContent = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    flex-direction: row;
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding-left: 65px;
    padding-right: 65px;
    margin: 0 auto;
    max-width: 1280px;
    align-items: flex-start;
  }
`;

export const StyledTitle = styled.div`
  padding: 40px 8% 8px;

  & > h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 38px;
    color: #233247;
  }

  & > p {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    padding-left: 16px;
    color: #586981;
    border-left: 3px solid #15ef81;
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    padding: 0;
    min-width: 250px;
    margin-left: 8%;
    max-width: 320px;
    align-self: center;
    & > h2 {
      margin-bottom: 92px;
    }
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    margin-left: 0;
    margin-right: 20px;
    min-width: 330px;
  }
`;
export const StyledList = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  margin-top: 50px;
  color: #586981;
  padding: 0 6%;
  justify-content: space-between;

  & > p > span {
    margin-top: 20px;
    width: 100%;
    padding: 0 10px;
    font-size: 12px;
  }

  & > p {
    width: 30%;

    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 42px;
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    margin-bottom: 38px;
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding: 0;
    margin: 98px auto 130px;
    //max-width: 520px;
    & > p {
      width: 16.6%;
    }
    & > p > span {
      font-size: 16px;
      line-height: 21px;
    }
  }
`;
